var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingStatus)?_c('div',{staticClass:"loading-container"},[_c('van-loading',{staticClass:"loading",attrs:{"type":_vm.type,"color":_vm.color}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }